import { module as modujs } from "modujs";
import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				button: "changeTab",
			},
		};

		this.isDragging = false;
		this.startX = 0;
		this.currentIndex = 0;
	}

	init() {
		this.$buttons = this.$("button");
		this.$items = this.$("item");
		this.$container = this.$("container")[0];

		// Add touch and mouse event listeners
		// this.$container.addEventListener("touchstart", this.handleDragStart.bind(this));
		// this.$container.addEventListener("touchmove", this.handleDragMove.bind(this));
		// this.$container.addEventListener("touchend", this.handleDragEnd.bind(this));

		// this.$container.addEventListener("mousedown", this.handleDragStart.bind(this));
		// this.$container.addEventListener("mousemove", this.handleDragMove.bind(this));
		// this.$container.addEventListener("mouseup", this.handleDragEnd.bind(this));
		// this.$container.addEventListener("mouseleave", this.handleDragEnd.bind(this));
	}

	handleDragStart(e) {
		this.isDragging = true;
		this.startX = e.type === "mousedown" ? e.clientX : e.touches[0].clientX;
		this.currentIndex = Array.from(this.$buttons).findIndex((button) => button.classList.contains("-active"));
	}

	handleDragMove(e) {
		if (!this.isDragging) return;

		const currentX = e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
		const diff = this.startX - currentX;
		const threshold = 50; // Minimum distance to trigger tab change

		if (Math.abs(diff) > threshold) {
			const newIndex = diff > 0 ? Math.min(this.currentIndex + 1, this.$buttons.length - 1) : Math.max(this.currentIndex - 1, 0);

			if (newIndex !== this.currentIndex) {
				this.changeTab({ currentTarget: this.$buttons[newIndex] });
				this.currentIndex = newIndex;
				this.startX = currentX;
			}
		}
	}

	handleDragEnd() {
		this.isDragging = false;
	}

	changeTab(e) {
		const id = e.currentTarget.dataset.id;

		this.$buttons.forEach((button) => {
			button.classList.remove("-active");
		});

		this.$items.forEach((item) => {
			item.classList.remove("-active");
		});

		this.$buttons[id].classList.add("-active");
		this.$items[id].classList.add("-active");
	}

	destroy() {
		// Remove event listeners
		this.$container.removeEventListener("touchstart", this.handleDragStart.bind(this));
		this.$container.removeEventListener("touchmove", this.handleDragMove.bind(this));
		this.$container.removeEventListener("touchend", this.handleDragEnd.bind(this));

		this.$container.removeEventListener("mousedown", this.handleDragStart.bind(this));
		this.$container.removeEventListener("mousemove", this.handleDragMove.bind(this));
		this.$container.removeEventListener("mouseup", this.handleDragEnd.bind(this));
		this.$container.removeEventListener("mouseleave", this.handleDragEnd.bind(this));
	}
}
